<template>
  <el-dialog
    width="30%"
    title="Adicionar produto ao pedido"
    append-to-body
    v-model="shouldShow"
  >
    <h4 class="mb-0">Produto:</h4>
    <el-select
      filterable
      remote
      v-model="productOrder.product"
      :loading="!products"
      value-key="uid"
      loading-text="Buscando produtos..."
      :remote-method="searchProducts"
      size="medium"
    >
      <el-option
        v-for="item in Products"
        :disabled="!item.is_active"
        :key="item.uid"
        :label="item?.product?.name"
        :value="item"
      >
      </el-option>
    </el-select>

    <h4 class="mb-0">Quantidade:</h4>
    <base-input
      v-model="productOrder.quantity"
      :minimumFractionDigits="3"
      validationRules="required"
      @validation="validationResult['quantity'] = $event"
      type="money"
    >
    </base-input>

    <h4 class="mb-0">Un. de medida:</h4>
    <el-select v-model="productOrder.un_quantity" size="medium">
      <el-option
        v-for="item in QuantityMeasurement"
        :key="item"
        :label="item"
        :value="item"
      >
      </el-option>
    </el-select>

    <h4 class="mb-0">Preço por Kg:</h4>
    <base-input v-model="productOrder.amount" type="money">
      <template #append v-if="productOrder.product?.price">
        Ref:
        {{
          currencyFormatter.format(
            Number(productOrder.product?.price?.female_std)
          )
        }}
      </template>
      <template
        #prefix
        v-if="productOrder.amount && productOrder.product?.price"
      >
        <el-icon
          size="small"
          class="el-icon-arrow-down"
          color="red"
          style="line-height: 36px"
          v-if="
            Number(productOrder.amount) <
            Number(productOrder.product?.price?.female_std)
          "
        ></el-icon>
        <el-icon
          size="small"
          class="el-icon-arrow-up"
          color="green"
          style="line-height: 36px"
          v-else
        ></el-icon>
      </template>
    </base-input>

    <h4 class="mb-0">Peso:</h4>
    <base-input
      v-model="productOrder.weight"
      type="money"
      :minimumFractionDigits="3"
    ></base-input>

    <h4 class="mb-0">Forma de armazenamento:</h4>
    <el-select v-model="productOrder.storage" size="medium">
      <el-option
        v-for="item in StorageProperties"
        :key="item"
        :label="item.name"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <template #footer>
      <el-row justify="space-between" type="flex">
        <el-button type="text" class="button" @click="shouldShow = false"
          >Cancelar</el-button
        >
        <el-button type="text" class="button" @click="addProductOrder"
          >Adicionar produto</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import BaseInput from "../../components/BaseInput.vue";
import ProductService from "../../services/products";
import { ElNotification } from "element-plus";
import { currencyFormatter } from "../../utils/formatters";
export default {
  name: "AddProductOrderModal",
  props: ["showModal"],
  components: { BaseInput },
  emits: ["onAddProduct", "closeModal"],
  computed: {
    shouldShow: {
      get() {
        return this.showModal;
      },
      set() {
        return this.$emit("close-modal");
      },
    },
    Products() {
      return this.mountedProducts() || [];
    },
    StorageProperties() {
      return [
        { name: "Resfriado", value: "cold" },
        { name: "Congelado", value: "freezed" },
      ];
    },
    QuantityMeasurement() {
      return ["Peso", "Peça"];
    },
    AnimalSex() {
      return [
        { label: "Macho", value: "male" },
        { label: "Fêmea", value: "female" },
      ];
    },
  },
  data: () => ({
    productOrder: {},
    products: null,
    validationResult: {},
    currencyFormatter,
  }),
  methods: {
    mountedProducts() {
      return (
        this.products
          ?.map((p) =>
            p?.mounted
              .map((m) => ({
                ...p,
                ...(m?.codes || {}),
                uid: m.id,
                price: m?.price,
                productUid: p.uid,
                product: {
                  name: `${p.name} ${m.cutting ?? ""} ${m.composition ?? ""} ${
                    m.storage ?? ""
                  }`,
                },
              }))
              ?.flat()
          )
          ?.flat() || []
      );
    },
    async searchProducts(name) {
      const { products } = await ProductService().index({ searchName: name });

      if (products) {
        this.products = products;
      }
    },
    hasEmptyInputs() {
      return (
        !this.productOrder.product ||
        !this.productOrder.un_quantity ||
        !this.productOrder.quantity
      );
    },
    addProductOrder() {
      if (this.hasEmptyInputs())
        return ElNotification.error({
          title: "Não é possível adicionar este produto",
          message:
            "Informe corretamente um produto, peso e preço antes de adicionar",
        });
      this.$emit("on-add-product", this.productOrder);
      this.$emit("close-modal");
    },
  },
};
</script>
